import React from 'react';
import { MOTOR_POWER_ROWS } from '../../constants/latest-asset-trend.constant';
import GenericEspWidget from './GenericEspWidget';

const MotorPowerWidget: React.FC = () => <GenericEspWidget title='Motor power' rowsConfig={MOTOR_POWER_ROWS} />;

export default MotorPowerWidget;
